export default __webpack_public_path__ + "static/media/reddit.b7bb65d7.svg";